<template>
  <b-modal
    ref="hikvision_dvrs"
    id="hikvision-dvrs"
    @show="onShow"
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    scrollable
    size="lg"
    centered
  >
    <div style="height: 525px; max-width: 100%; overflow-y: auto">
      <b-card no-body class="m-2">
        <b-card-body>
          <b-row>
            <b-col cols="12" md="12" class="mb-md-0 mb-2 text-capitalize">
              <label>{{ $tc('vxg_master_account.title', 1) }}</label>
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="filterMasterAccount"
                :options="hikvisionMasterAccountOptions"
                class="w-100"
                :reduce="(val) => val.value"
                multiple
              />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-card class="m-2" no-body>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="text-capitalize">{{ $t("table.show") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label class="text-capitalize">{{ $t("table.entries") }} </label>
            </b-col>

            <!-- <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  class="d-inline-block mr-1"
                  :placeholder="$t('table.search') + '...'"
                  v-model="searchQuery"
                />
              </div>
            </b-col> -->
          </b-row>
        </div>
        <b-table
          ref="refListTable"
          class="position-relative"
          :items="fetchList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="$t('no_record_found')"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template #head(encodeDevName)="data">
            <span> {{ $t(data.label) }}</span>
          </template>

          <template #head(encodeDevIp)="data">
            <span> {{ $t(data.label) }}</span>
          </template>

          <template #cell(id)="data">
            <b-form-checkbox
              :disabled="data.item.exist"
              :id="`dvr-${data.item.encodeDevIndexCode}-${data.item.id_hikvision_master_account}`"
              :value="data.item"
              v-model="dvrsApi"
            >
            </b-form-checkbox>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted text-capitalize">{{
                $t("table.showing", {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}</span>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalList"
                :per-page="perPage"
                prev-class="prev-item"
                next-class="next-item"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <template #modal-footer>
      <b-button
        variant="info"
        size="sm"
        class="text-capitalize"
        :disabled="buttonUpdate"
        @click="updateHikivisonDvrs"
      >
        {{ $t("actions.update") }}
      </b-button>
      <b-button
        size="sm"
        variant="secondary"
        class="text-capitalize"
        :disabled="buttonUpdate"
        @click="$bvModal.hide('hikvision-dvrs')"
      >
        {{ $t("actions.cancel") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BCard, BRow, BCol, BFormInput, BTable, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, watch, computed, nextTick } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import Pagination from "@/components/Pagination.vue";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import { debounce } from "lodash";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    vSelect,
    Pagination,
    ToastificationLoadingContent,
  },
  props: {
    hikvisionMasterAccountOptions: {
      type: Array,
      default: null,
    },
    hikvisionMasterAccountFilter: {
      type: Array,
      default: null,
    },
  },

  setup(props, { emit }) {
    const isBusy = ref(false);
    const refListTable = ref(null);
    const perPage = ref(10);
    const totalList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const buttonUpdate = ref(false);
    const offset = ref(0);
    const searchQuery = ref(null);
    const search = ref(false);
    const cameras = ref([]);
    const dvrsApi = ref([]);
    const camerasTemp = ref([]);
    const selectAll = ref(0);
    const hikvision_dvrs = ref(null);
    const loadingToast = ref(null);
    const toast = useToast();
    const excludeCameras = ref([]);
    const filterMasterAccount = ref([]);
    const openModal = ref(false);

    const fetchList = (ctx, callback) => {
      offset.value = currentPage.value * perPage.value - perPage.value;

      store.dispatch("hikvision_master_account/syncDvrs", {
        pageNo: currentPage.value,
        pageSize: perPage.value,
        masterAccounts: filterMasterAccount.value
      })
        .then((response) => {
          const { data } = response;

          callback(data.data);
          checkCameraExist(data.data);

          totalList.value = data.totalList;
          /* if (response.success) {

            callback(response.data.cameras.objects);
            camerasTemp.value = response.data.cameras.objects;
            totalList.value = response.data.cameras.meta.total_count;
            search.value = searchQuery.value && totalList.value > 0 ? true : false;

            if (search.value) {
              if(Number(selectAll.value)){
                if(excludeCameras.value.length > 0){
                  let res = camerasTemp.value.filter(obj1 =>
                    !excludeCameras.value.some(obj2 => obj1.id === obj2.id)
                  );
                  camerasId.value = res.map(camera => camera.id)
                }
                else{
                  camerasId.value = camerasTemp.value.map(camera => camera.id)
                }
              }
              else{
                camerasId.value = cameras.value.map(camera => camera.id)
              }
            }

            checkCameraExist(); */

        })
        .catch((response) => {
          console.log('catch', response);
          toast({
            component: ToastificationContent,
            props: {
              title: response.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value
        ? refListTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalList.value,
      };
    });

    watch(filterMasterAccount, () => {
      if(openModal.value){
        fetchList();
      }
      else{
        openModal.value = true;
      }
    });

    watch(selectAll, () => {
      checkAll();
    });

    watch([currentPage, perPage], () => {
      refetchData();
    });

    watch(
      [searchQuery],
      debounce(() => {
        clear();
        refetchData();
      }, 800)
    );

    const refetchData = () => {
      refListTable.value.refresh();
    };

    const checkAll = () => {
      if(Number(selectAll.value)){
        camerasId.value = camerasTemp.value.map(camera => camera.id)
      }
      else{
        camerasId.value = [];
        checkCameraExist()
      }
    };

    const clear = () => {
      selectAll.value = 0;
      cameras.value = [];
      dvrsApi.value = [];
      excludeCameras.value = [];
    };

    const checkItem = (id) => {
      const cam  = camerasTemp.value.find(camera => id == camera.id);

      if(Number(selectAll.value)){
        if(excludeCameras.value.find(item => item.id === id)){
          let cams =  excludeCameras.value.filter(item => item.id !== id);
          excludeCameras.value = cams;
        }
        else{
          excludeCameras.value.push(cam)
        }
      }
      else{
        if(cameras.value.find(item => item.id === id)){
          let cams =  cameras.value.filter(item => item.id !== id);
          cameras.value = cams;
        }
        else{
          cameras.value.push(cam)
        }
      }
    }

    const updateHikivisonDvrs = async () => {
      emit("loading-toast-event", { data: true });

      buttonUpdate.value = true;

      await store
        .dispatch("hikvision_dvr/add", { dvrs: dvrsApi.value })
        .then((response) => {
          clear();
          refetchData();

          hikvision_dvrs.value.hide();

          emit("loading-toast-event", { data: false });
        })
        .catch((error) => {

          toast({
            component: ToastificationContent,
            props: {
              title: "Error al actualizar cámaras",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });

          emit("loading-toast-event", { data: false });
        })
        .finally(() => {
          buttonUpdate.value = false;
        });
    };

    const checkCameraExist = (dvrs) => {
      nextTick(() => {
        dvrs.forEach(dvr => {
          const { exist } = dvr;

          if (exist) {
            dvrsApi.value.push(dvr);
          }
        });
      });
    };

    const onShow = () => {
      openModal.value = false;

      filterMasterAccount.value = props.hikvisionMasterAccountFilter;

      if (props.hikvisionMasterAccountFilter === null) {
        openModal.value = true;
      }
    };

    return {
      isBusy,
      perPage,
      totalList,
      currentPage,
      perPageOptions,
      refListTable,
      tableColumns: [
        { label: "", key: "id", sortable: false },
        { label: "hikvision_dvr.name", key: "encodeDevName" },
        { label: "hikvision_dvr.ip", key: "encodeDevIp" }
      ],
      buttonUpdate,
      selectAll,
      dvrsApi,
      cameras,
      dataMeta,
      loadingToast,
      hikvision_dvrs,
      searchQuery,
      search,
      fetchList,
      checkItem,
      updateHikivisonDvrs,
      onShow,
      openModal,
      filterMasterAccount,
    };
  },
};
</script>
